import axios, { AxiosResponse } from "axios";
import { TFunction } from "i18next";

import { FileItem, FileRejection, FileStatus } from "../types/common";

export const download = (
  fileName: string,
  { data, headers }: AxiosResponse
) => {
  const type = headers["content-type"];
  const blob = new Blob([data], { type });

  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, fileName);
    return;
  }

  const link = document.createElement("a");
  const body = document.getElementsByTagName("body")[0];

  link.href = window.URL.createObjectURL(blob);

  if (type !== "application/octet-stream") {
    link.target = "_blank";
  } else {
    link.download = fileName;
  }
  body.appendChild(link);
  link.click();
  body.removeChild(link);
};

export const downloadFile = (path: string, fileName: string) =>
  axios
    .get(path, {
      responseType: "blob",
    })
    .then((res) => download(fileName, res));

export const getFileErrors = (
  files: FileRejection[],
  additionalError: string,
  t: TFunction
): string[] => {
  const errorMapper: { [key: string]: string } = {
    "file-invalid-type": t("uploader.failedExtensionError"),
    "file-too-large": t("uploader.sizeError"),
    "too-many-files": t("uploader.fileCountError"),
  };

  const errors = files.reduce((acc, rejectedFile) => {
    const { errors: fileErrors } = rejectedFile;
    let existedErrors = [...acc];

    fileErrors.forEach((item) => {
      const errorText = errorMapper[item.code];

      if (!existedErrors.includes(errorText)) {
        existedErrors = [...existedErrors, errorText];
      }
    });

    return existedErrors;
  }, [] as string[]);

  if (additionalError && !errors.includes(errorMapper[additionalError])) {
    return [...errors, errorMapper[additionalError]];
  }

  return errors;
};

export const fileListMapper = (files: FileItem[]) =>
  files.map((file) => ({
    ...file,
    status: FileStatus.Loaded,
  }));
